import { render, staticRenderFns } from "./AppLayout.vue?vue&type=template&id=ba3a8d3a&scoped=true&"
import script from "./AppLayout.vue?vue&type=script&lang=ts&"
export * from "./AppLayout.vue?vue&type=script&lang=ts&"
import style0 from "./AppLayout.vue?vue&type=style&index=0&id=ba3a8d3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3a8d3a",
  null
  
)

export default component.exports